import React from 'react';
import { useState, useRef, useEffect } from 'react';
import { Text, useIamValidation } from '@smarterservices/smarter-ui';
import InPlaceEdit from '../../Common/InPlaceEdit';
import { getStore } from '../../../stores/StoreContext';

const nonPluralize = (str) => str.replace('s', '').toLowerCase();

const AnnotationDetails = ({ annotation, onHeightChange }) => {
  const [comment, setComment] = useState(annotation?.comment || '');
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const deleteButtonRef = useRef(null);
  const ExamSessionStore = getStore('examSessionStore');
  const AppStore = getStore('appStore');

  const { checkPermission } = useIamValidation();

  // Focus the delete button when deleteConfirm becomes true
  useEffect(() => {
    if (deleteConfirm && deleteButtonRef.current) {
      deleteButtonRef.current.focus();
    }
  }, [deleteConfirm]);

  // Update comment state when annotation changes
  useEffect(() => {
    setComment(annotation?.reviewerComment || '');
  }, [annotation]);

  // Handle details change
  const handleDetailsChange = async ({ oldText, newText }) => {
    try {
      const updateResult = await ExamSessionStore.updateAnnotation(
        annotation.sid,
        {
          details: newText,
          //TODO: Update the users name...
          updatedBy: 'admin',
          updatedDate: new Date().toISOString(),
        }
      );
      if (!updateResult.successful) {
        return { success: false, message: 'Failed to update details' };
      }

      // Trigger row height recalculation after details change
      if (onHeightChange) {
        setTimeout(() => onHeightChange(), 0);
      }

      // For now, we'll simulate a successful update
      return { success: true };
    } catch (error) {
      // If there's an error, return it to display in the UI
      console.log(error);
      return {
        success: false,
        message: error.message || 'Failed to update details',
      };
    }
  };

  return (
    <Text as="div" variant="contentSmall">
      {checkPermission('sp:ModifyExamAnnotation', AppStore.getIamResourceString(`session/${ExamSessionStore.sessionSid}`)) ? (
        <InPlaceEdit
          text={annotation?.details}
          placeholder={`Provide additional details about this ${annotation?.type?.categoryId ? nonPluralize(annotation?.type?.categoryId) : ''}...`}
          onChange={handleDetailsChange}
        />
      ) : (
        <>
          {annotation?.details}
        </>
      )}
    </Text>
  );
};

export default AnnotationDetails;
